<div [formGroup]="userLicenceForm" class="form flex flex-col">
  <nx-edit-select-input
    formControlName="licenceType"
      [options]="licenceOptions"
      label="Lizenz">
  </nx-edit-select-input>
<div>